import React from "react";
import { STATS } from "../../data";
import { Reveal } from "../ui/Reveal";
import { SectionHeader } from "../ui/SectionHeader";

const EDUCATION = [
  {
    year: "2025",
    degree: "Master of Information Technology",
    school: "RMIT University — Melbourne, VIC",
    featured: true,
  },
  {
    year: "2021",
    degree: "B.Sc. Computer Engineering (Hons)",
    school: "University of Sri Jayewardenepura — Colombo",
    featured: false,
  },
  {
    year: "2015",
    degree: "G.C.E Advanced Level — Physical Science",
    school: "Holy Cross College — Kalutara · District Rank: 45",
    featured: false,
  },
] as const;

export const About: React.FC = () => (
  <section id="about">
    <div className="section-wrap">
      <SectionHeader
        label="About Me"
        title={
          <>
            Engineer, not just <em>a coder.</em>
          </>
        }
      />

      <div className="about-layout">
        {/* ── Body text ── */}
        <Reveal delay={80} className="about-text">
          <p>
            I'm a <strong>Full Stack Software Engineer</strong> who cares about
            the full picture — from architecting cloud-native systems to
            sweating the UX details on a form input. Three years of production
            work across <strong>Sri Lanka and Australia</strong> have given me a
            deep respect for code that ships, scales, and stays maintainable.
          </p>

          <div className="about-quote">
            "Turning complex requirements into simple, user-focused solutions
            through close collaboration and practical problem-solving."
          </div>

          <p>
            My core stack is <strong>React, TypeScript, and Node.js</strong>,
            extended by Java, Python, AWS, and a wide range of SQL/NoSQL
            databases. I'm comfortable writing automated tests (Jest, Cypress,
            Playwright), setting up CI/CD pipelines, and leading technical
            discussions across Agile teams.
          </p>

          <p>
            I recently completed a{" "}
            <strong>Master of Information Technology at RMIT University</strong>{" "}
            focusing on secure systems, cloud architecture, and AI integration.
          </p>

          {/* Stats grid */}
          <div className="stats-grid">
            {STATS.map((s) => (
              <div key={s.label} className="stat-box">
                <div className="stat-num">{s.num}</div>
                <div className="stat-label">{s.label}</div>
              </div>
            ))}
          </div>
        </Reveal>

        {/* ── Education cards ── */}
        <Reveal delay={160}>
          <div className="edu-stack">
            {EDUCATION.map((edu) => (
              <div
                key={edu.year}
                className={`edu-card${edu.featured ? " top" : ""}`}
              >
                <div className="edu-year">{edu.year}</div>
                <div className="edu-deg">{edu.degree}</div>
                <div className="edu-school">{edu.school}</div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
